import React from "react";

/**
 * A reusable badge/tag component that matches the style used for "Personal Injury & Workers' Comp".
 * Use it for category tags, badges, and other short label elements that need consistent styling.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content of the badge.
 * @param {string} [props.className] - Additional class names.
 * @param {string} [props.as] - HTML element to render (default: "span").
 */
const Badge = ({ children, className = "", as: Component = "span", ...props }) => (
  <Component className={["badge", className].filter(Boolean).join(" ")} {...props}>
    {children}
  </Component>
);

export default Badge;
